import { ValidationError } from "sequelize"
import {
    MarkovRedistribution,
    MarkovRedistributionCreate,
    MarkovRedistributionSave,
} from "server/models"
import { ASC } from "const"
import { GET, POST, DELETE, sort, validate } from "client/store/utils"
import { LangType } from "client/store"
import { MarkovRedistributionValidation } from "./types"


export const LoadAllMarkovRedistributions = (modelId: number) => (
    GET(`/markovRedistribution/modelId/${modelId}`)
    .then((redistributions: MarkovRedistribution[]) => (
        redistributions.sort((a, b) => sort(a, b, "order", ASC))
    ))
)

export const LoadMarkovRedistributionById = (redistributionId: number, modelId: number) => (
    GET(`/markovRedistribution/id/${redistributionId}/modelId/${modelId}`)
    .then((redistribution: MarkovRedistribution) => redistribution)
)

export const SaveMarkovRedistribution = (
    id: number,
    redistribution: MarkovRedistributionCreate,
    lang: LangType,
) => {
    const data: MarkovRedistributionSave = {
        id,
        redistribution,
    }
    return POST(
        "/markovRedistribution/save",
        JSON.stringify(data),
    ).then((res) => {
        const newRedistribution = res as MarkovRedistribution
        const error = res as ValidationError

        return {
            newRedistributionId: newRedistribution.id || null,
            validation: <MarkovRedistributionValidation>validate(error, lang),
        }
    })
}

export const DeleteMarkovRedistribution = (redistributionId: number, modelId: number) => (
    DELETE(`/markovRedistribution/delete/${redistributionId}/${modelId}`)
    .then((removedRows: number) => removedRows)
)
